import React from "react";

import JustifiedGrid from "core/JustifiedGrid";
import HoverTextOverlay from "core/HoverTextOverlay";

import { GridViewContainer, Image } from "./styles";

import { usePhotoUploadPreviewData } from "../../PhotoUploadCore/hooks";

const ImagesContainerGridView = ({ uploads }) => {
    const { getUploadPreview } = usePhotoUploadPreviewData();

    const itemRatios = [];

    const items = uploads.map(upload => {
        const { id, photoTitle, originalFilename } = upload;
        const uploadPreview = getUploadPreview(id);
        const uploadName = photoTitle || originalFilename;

        if (!uploadPreview) return null;

        itemRatios.push(uploadPreview.aspectRatio);

        return (
            <GridViewContainer key={id}>
                <Image
                    src={uploadPreview.preview}
                    alt={`File name ${uploadName}`}
                />

                <HoverTextOverlay
                    hoverText={uploadName}
                    textSize="xs"
                    textContainerType="div"
                />
            </GridViewContainer>
        );
    });

    return (
        <JustifiedGrid
            items={items}
            itemRatios={itemRatios}
            itemSpacing={16}
            targetRowHeight={120}
        />
    );
};

export default ImagesContainerGridView;
